import toast from "react-hot-toast";
import { apiConnector } from "../apiConnector";
import { paymentEndpoints } from "../api";
import rgpLogo from "../../assets/Logo/rzp_logo.png"
import { resetCart } from "../../slices/cartSlice";
import { NavigateFunction } from "react-router-dom";
import { AppDispatch } from "../..";

type BuyCourseData = {
  courses: string[];
};

type RazorpayResponse = {
  razorpay_payment_id: string;
  razorpay_order_id: string;
  razorpay_signature: string;
};

const {COURSE_PAYMENT_API,COURSE_VERIFY_API} = paymentEndpoints;

const loadScript = (src:string):Promise<boolean> => {
    return new Promise((resolve)=> {
        const script:HTMLScriptElement = document.createElement("script");
        script.src = src

        script.onload = () => {
            resolve(true)
        }

        script.onerror = () => {
            resolve(false);
        }
     document.body.appendChild(script);
    })
}

export const buyCourse = async (
  data: BuyCourseData,
  token: string,
  user_details: any,
  navigate: NavigateFunction,
  dispatch: AppDispatch
): Promise<void> => {
  const { courses } = data;
  const toastId = toast.loading("Loading...");

  try {
    const res: boolean = await loadScript(
      "https://checkout.razorpay.com/v1/checkout.js"
    );

    if (!res) {
      toast.error(
        "Razorpay SDK failed to load. Check your Internet Connection."
      );
      return;
    }

    const result = await apiConnector<any>(
      "POST",
      COURSE_PAYMENT_API,
      data,
      {
        Authorization: `Bearer ${token}`,
      }
    );

    console.log("PAYMENT RESPONSE FROM BACKEND............", result.data);

    const options = {
      key: process.env.REACT_APP_RAZORPAY_KEY as string,
      currency: result.data.data.currency,
      amount: `${result.data.data.amount}`,
      order_id: result.data.data.id,
      name: "StudyNotion",
      description: "Thank you for Purchasing the Course.",
      image: rgpLogo,
      prefill: {
        name: `${user_details.firstName} ${user_details.lastName}`,
        email: user_details.email,
      },
      handler: function (response: RazorpayResponse) {
        verifyPayment(
          { ...response, courses },
          token,
          navigate,
          dispatch
        );
      },
    };

    const rzp1 = new window.Razorpay(options);
    rzp1.open();

    rzp1.on("payment.failed", function (response: any) {
      alert(response.error.code);
      console.log(response);
    });
  } catch (err: unknown) {
    console.log(err, "error occur in buying course");
    toast.error("Could not make payment");
  }

  toast.dismiss(toastId);
};


// Verify the Payment
async function  verifyPayment(bodyData:any, token:string,navigate:NavigateFunction,dispatch:AppDispatch) {

    const toastId = toast.loading("Verifying Payment...")
    
    try {
      const response = await apiConnector<any>("POST", COURSE_VERIFY_API, bodyData, {
        Authorization: `Bearer ${token}`,
      })
  
      console.log("VERIFY PAYMENT RESPONSE FROM BACKEND............", response)
  
      if (!response.data.success) {
        throw new Error(response.data.message)
      }
  
      toast.success("Payment Successful. You are Added to the course ")
      navigate("/dashboard/enrolled-courses")
      if(dispatch){
        dispatch(resetCart())
      }
    } catch (error) {
      console.log("PAYMENT VERIFY ERROR............", error)
      toast.error("Could Not Verify Payment.")
    }
    toast.dismiss(toastId)
}

